import { Fragment, ReactNode, useContext } from 'react';

import { makeStyles } from '@material-ui/core';

import { AddFilterButtonMui } from './AddFilterButtonMui';
import { FilterSearchMui } from './FilterSearchMui';
import { FILTER_CONTEXT } from './provider';

const useStyles = makeStyles(theme => ({
  topContainer: {
    display: 'flex',
    maxWidth: '275px',
    gap: 'var(--encore-spacing-tighter-2)',
    alignItems: 'center',
    gridRow: 2,
    gridColumn: '1 / -1',
    [theme.breakpoints.up('sm')]: {
      gridRow: 1,
      gridColumn: 'auto',
    },
  },
  chipContainer: {
    display: 'flex',
    width: '100%',
    gap: 'var(--encore-spacing-tighter-2)',
    paddingTop: 'var(--encore-spacing-base)',
    paddingBottom: 'var(--encore-spacing-tighter-2)',
    gridRow: 3,
    gridColumn: '1 / -1',
    [theme.breakpoints.up('sm')]: {
      gridRow: 2,
    },
  },
}));

interface FilterControlsMuiProps {
  searchCollapsed?: boolean;
  hideSearch?: boolean;
  debounceTime?: number;
}

export const FilterControlsMui = ({
  searchCollapsed = false,
  hideSearch = false,
  debounceTime = 300,
}: FilterControlsMuiProps) => (
  <>
    {!hideSearch && (
      <FilterSearchMui
        searchCollapsed={searchCollapsed}
        debounceTime={debounceTime}
      />
    )}
    <AddFilterButtonMui />
  </>
);

export const FilterBarMui = ({ children }: { children?: ReactNode }) => {
  const classes = useStyles();
  return (
    <Fragment>
      <div className={classes.topContainer}>
        <FilterControlsMui />
        {children}
      </div>
      <ActiveFiltersMui />
    </Fragment>
  );
};

export function ActiveFiltersMui() {
  const classes = useStyles();
  const context = useContext(FILTER_CONTEXT);

  if (!context)
    throw new Error('ActiveFilters must be used within a FiltersProvider');

  const { activeFilters, removeFilter, addFilter } = context;

  if (activeFilters.length === 0) return null;

  return (
    <div className={classes.chipContainer}>
      {activeFilters.map(activeFilter => (
        <Fragment key={`filter-${activeFilter.id}`}>
          {activeFilter.renderViewer({
            onValueChange: newValue => addFilter(activeFilter, newValue),
            onRemove: () => removeFilter(activeFilter.id),
          })}
        </Fragment>
      ))}
    </div>
  );
}
